var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiBetbuilderContainer',[_c('UiBetbuilderHeader',{on:{"clear":_vm.clear,"close":_vm.close,"openSettings":_vm.openSettings}}),_vm._v(" "),_c('UiBetbuilderSummary',[_c('betbuilder-calc')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }